import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import tt from'../../../pip/library/pi-tt/pi-tt.js';
import { IHIHTTP } from 'src/types/hip_types';

export interface ILoadingModuleConfiguration extends IModuleConfiguration {
  storage_key: string;
}

declare global {
  interface Window {
    ['HIP']: any;
  }
}

export class LoadingModule extends ModuleConfiguration {
  configuration: ILoadingModuleConfiguration;

  initialize(configuration: ILoadingModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);
      resolve(this.configuration);
    });
  }

  private __defaultConfiguration(configuration: ILoadingModuleConfiguration) {
    return tt.mergeWith('clobber', {}, configuration) as ILoadingModuleConfiguration;
  }

  activate(configuration: { loading: ILoadingModuleConfiguration }) {
    return new Promise((resolve) => {
      window.HIP.aop.pointCut('hi-http', 'invoke', (actualInvokeFunctionOnHTTP: Function) => {
        let count = 0;
        // TODO: This will annouce with the loading animation
        window.HIP.fn.announce('Start Loading');
        return function (this: IHIHTTP, httpPayload: unknown) {
          count += 1;
          return actualInvokeFunctionOnHTTP.call(this, httpPayload).then((value: any) => {
            count -= 1;
            if (count <= 0) {
              // TODO: This will annouce with the loading animation
              window.HIP.fn.announce('Loading Completed');
              console.log('hide loading graphic');
            }
            return value;
          });
        };
      });

      resolve();
    });
  }
}
